import React from 'react';
import { Box } from '@mui/material';
import {
  BadgePercent,
  CalendarDays,
  Compass,
  MapPin,
  MessageSquareText,
  UsersRound
} from 'lucide-react';
import { NAV_TABS } from '../../utils/categoriesConfig';
import TTSButton from '../Mobile/TTSButton';
import './NavigationBar.css';

const TAB_ICONS = {
  Explore: Compass,
  Events: CalendarDays,
  Reviews: MessageSquareText,
  Reviewers: UsersRound,
  Places: MapPin,
  Promotion: BadgePercent
};

const NavigationBar = ({
  type,
  setType,
  language,
  onTTSToggle,
  isTTSPlaying,
  isTTSDisabled,
  audioOutputDevices,
  selectedOutputDeviceId,
  onOutputDeviceChange,
  onTTSRestart
}) => {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      minWidth: 0,
      overflow: 'hidden',
      borderBottom: '1px solid #e3eaf0',
      backgroundColor: '#f8fafc',
      padding: '0.625rem',
      gap: 1
    }}>
      <Box sx={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
        <div className="desktop-scroll-container" role="tablist" aria-label="Content categories">
          {NAV_TABS.map(tab => {
            const Icon = TAB_ICONS[tab.id];
            const isActive = type === tab.id;

            return (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                data-value={tab.id}
                className={`desktop-nav-item ${isActive ? 'active' : ''}`}
                onClick={() => setType(tab.id)}
              >
                {Icon && <Icon className="desktop-nav-icon" aria-hidden="true" />}
                <span>{tab.label[language] || tab.label.EN}</span>
              </button>
            );
          })}
        </div>
      </Box>

      {/* TTS Button */}
      {onTTSToggle && (
        <Box sx={{ flexShrink: 0, paddingRight: '0.5rem' }}>
          <TTSButton
            isPlaying={isTTSPlaying}
            isDisabled={isTTSDisabled}
            onToggle={onTTSToggle}
            audioOutputDevices={audioOutputDevices}
            selectedOutputDeviceId={selectedOutputDeviceId}
            onOutputDeviceChange={onOutputDeviceChange}
            onRestart={onTTSRestart}
          />
        </Box>
      )}
    </Box>
  );
};

export default NavigationBar;
